import { z } from 'zod';

export const count = (num: number) => num.toString().padStart(2, '0');

// `Link.action` is resolved from the link's own config version, so the flag is
// correct per version: a link created while the action was a migration stays
// flagged even if the flag is later removed from the action.
const migrationActionSchema = z.object({ isMigration: z.boolean().nullish() });

export const isMigrationLink = (link: { action?: unknown }): boolean => {
  const parsed = migrationActionSchema.safeParse(link?.action);
  return parsed.success && parsed.data.isMigration === true;
};
